const accordionWrapperProperties = `
  isAlphabetTabEnabled
  variant
  contentCollection(limit: 20) {
    items {
      heading
      description
      image{
        title
        description
        url
        width
        height                          
      }
      includedItemsHeading
      activeIndex
      elementId
      endNotes{
        content
        elementId
      }
      contentCollection(limit: 20) {
         items {
            title
            description
            shortDescription
            imagesCollection(limit: 5) {
              items {
                title
                description
                url
                width
                height                          
              }
            }
            mainImage{
              internalTitle
              altText
              imageDesktop {
                title
                description
                url
                width
                height
              }
              imageMobile {
                title
                description
                url
                width
                height
              }
              bgDesktop {
                title
                description
                url
                width
                height
              }
              bgMobile {
                title
                description
                url
                width
                height
              }
            }
            relatedItems{
              heading
              array
            }
            linkButton {
              name
              url
              label
              title
              target
              elementId
              scrollToElementId
              imageType
              gaEventClass
              gaEventLabel
            }
            endNotes{
              content
              elementId
            }
          }
        }
      }
    }
`
const query = (id, isPreview) => `{
    accordionWrapper(id: "${id}", preview: ${isPreview}){
      ${accordionWrapperProperties}
    }
  }
  `
module.exports = { query,accordionWrapperProperties }
